import { Box, Typography, Select, MenuItem, Stack } from "@mui/material";
import { CallToActionProps } from "~/shared/types/types";
import {
  CTA_FALLBACK_ITEMS,
  CTA_FALLBACK_LANGUAGE_OPTIONS,
  getCallToActionOptions,
  resolveCallToActionText,
} from "~/shared/const/callToAction";
import { useGetCtaDictionaryOptionsQuery } from "~/features/dictionaries/model/api/cta-dictionary-api";

export const CallToAction = ({ value, language, onChange, onLanguageChange }: CallToActionProps) => {
  const { data } = useGetCtaDictionaryOptionsQuery();
  const languages = data?.data?.languages?.length
    ? data.data.languages
      .filter(item => item.is_active !== false)
      .map(item => ({ value: item.code, label: item.label }))
    : CTA_FALLBACK_LANGUAGE_OPTIONS;
  const items = data?.data?.items?.length
    ? data.data.items.filter(item => item.is_active !== false)
    : CTA_FALLBACK_ITEMS;
  const actions = getCallToActionOptions(language, items, languages);
  const hasCurrentValue = actions.some(action => action.value === value);
  const actionsWithCurrentValue = !value || hasCurrentValue
    ? actions
    : [
        ...actions,
        {
          value,
          label: resolveCallToActionText(value, language, items, languages) || value,
        },
      ];

  return (
    <Stack direction={{ xs: "column", md: "row" }} spacing={2} alignItems="stretch">
      <Box flex={1} minWidth={0}>
        <Typography fontWeight={600} variant="subtitle2">Язык CTA:</Typography>
        <Select
          fullWidth
          value={language}
          onChange={onLanguageChange}>
          {languages.map(option => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </Box>
      <Box flex={1} minWidth={0}>
        <Typography fontWeight={600} variant="subtitle2">Call to action:</Typography>
        <Select
          fullWidth
          value={value}
          onChange={onChange}>
          {actionsWithCurrentValue.map(action => (
            <MenuItem key={action.value} value={action.value}>
              {action.label}
            </MenuItem>
          ))}
        </Select>
      </Box>
    </Stack>
  );
};
